"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUploadDropArea = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var classnames = require("classnames");
var handleDrop_1 = require("../../utils/FileUpload/handleDrop");
var translation_1 = require("../../utils/translation");
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('FileUploadDropArea'), (0, recompose_1.withState)('hover', 'setHover', false), (0, recompose_1.defaultProps)({
    value: [],
    multipleFiles: true,
    disabled: false
}), (0, recompose_1.withHandlers)({
    handleDrop: handleDrop_1.handleDrop
}), recompose_1.pure);
exports.FileUploadDropArea = enhance(function (props) { return (React.createElement("div", { onDragEnter: function (e) {
        if (props.disabled) {
            return false;
        }
        return true;
    }, onDragOver: function (e) {
        e.stopPropagation();
        e.preventDefault();
        if (props.disabled) {
            props.setHover(false);
            return;
        }
        else {
            var types = e.dataTransfer.types;
            var showHover = false;
            for (var i = 0; i < types.length; i++) {
                if (types[i].toLowerCase() === 'files') {
                    showHover = true;
                    break;
                }
            }
            // Prevent browser from opening the file
            props.setHover(showHover);
        }
    }, onDragLeave: function (e) {
        // IE Fix: Ignore children's drag leave events
        if (e.target.classList.contains('sok-file-upload-drop-area')) {
            props.setHover(false);
        }
    }, onDrop: function (e) {
        if (props.disabled) {
            e.preventDefault();
            props.setHover(false);
            return false;
        }
        var len = e.dataTransfer.files.length;
        if (len < 1) {
            e.preventDefault();
            props.setHover(false);
            return false;
        }
        props.handleDrop(e);
    }, className: classnames('sok-file-upload-drop-area', props.className, props.hover && 'hover') },
    props.hover && (React.createElement("div", { className: "sok-file-upload-drop-area-hover" },
        React.createElement("span", { className: 'text' }, (0, translation_1.getLocalization)('userfront/files/dragAndDrop')))),
    props.children)); });
//# sourceMappingURL=index.js.map